import React, {useState} from "react";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Box,
  Button,
  Grid,
  Typography,
  TextField,
  Slider,
  MenuItem,
  Popover,
} from "@mui/material";
import { useWorkspace } from "../../../../contexts/WorkspaceContext";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import AddIcon from "@mui/icons-material/Add";
import Collapse from "@mui/material/Collapse";


const audienceOptions = [
   {
    category: "Business & Corporate",
    items: [
      "business executives",
      "C-suite executives",
      "board members",
      "investors",
      "shareholders",
      "venture capitalists",
      "business owners",
      "entrepreneurs",
      "startup founders",
      "managers and team leads",
      "sales professionals",
      "marketing teams",
      "HR professionals",
      "finance professionals",
      "consultants",
    ],
  },
  {
    category: "Education",
    items: [
      "students",
      "teachers",
      "educators",
      "university students",
      "high school students",
      "college professors",
      "school administrators",
      "parents",
      "academic researchers",
      "educational administrators",
    ],
  },
  {
    category: "Technical",
    items: [
      "software developers",
      "engineers",
      "data scientists",
      "IT professionals",
      "technical architects",
      "DevOps teams",
      "product managers",
      "UX/UI designers",
      "QA engineers",
      "system administrators",
    ],
  },
  {
    category: "Healthcare",
    items: [
      "healthcare professionals",
      "doctors",
      "nurses",
      "medical students",
      "hospital administrators",
      "patients",
      "caregivers",
      "pharmaceutical professionals",
      "medical researchers",
    ],
  },
  {
    category: "Government & Non-Profit",
    items: [
      "government officials",
      "policy makers",
      "non-profit organizations",
      "community leaders",
      "NGO workers",
      "social workers",
      "public servants",
    ],
  },
  {
    category: "Creative & Media",
    items: [
      "designers",
      "content creators",
      "marketers",
      "creative professionals",
      "media professionals",
      "journalists",
      "writers",
      "artists",
    ],
  },
  {
    category: "General Public",
    items: [
      "general public",
      "consumers",
      "community members",
      "local residents",
      "citizens",
      "young adults",
      "millennials",
      "Gen Z",
      "baby boomers",
    ],
  },
  {
    category: "Finance & Banking",
    items: [
      "financial advisors",
      "bankers",
      "accountants",
      "investment professionals",
      "wealth managers",
      "insurance agents",
    ],
  },
  {
    category: "Retail & E-commerce",
    items: [
      "retail managers",
      "e-commerce professionals",
      "store owners",
      "merchandisers",
      "retail buyers",
    ],
  },
  {
    category: "Manufacturing",
    items: [
      "manufacturing professionals",
      "supply chain managers",
      "operations managers",
      "quality control teams",
      "production managers",
    ],
  },
  {
    category: "Real Estate",
    items: [
      "real estate agents",
      "property developers",
      "real estate investors",
      "property managers",
    ],
  },
  {
    category: "Legal",
    items: ["lawyers", "legal professionals", "paralegals", "law students", "judges"],
  },
  {
    category: "Expertise Level Audiences",
    items: [
      "beginners",
      "novices",
      "intermediate users",
      "advanced users",
      "experts",
      "industry veterans",
      "early adopters",
      "decision makers",
      "influencers",
      "thought leaders",
    ],
  },
];


const TextContent = () => {

  const LevelOfDetail = ["brief", "medium", "detailed", "extensive"];
  const ToneOptions = ["professional", "casual", "friendly", "formal", "academic"];
  const LanguageOptions = [
    { code: "en", label: "English" },
    { code: "hi", label: "Hindi" },
    { code: "fr", label: "French" },
    { code: "es", label: "Spanish" },
    { code: "de", label: "German" }
  ];
  const AudienceOptions = ["General", "Students", "Executives", "Investors", "Developers"];
  const theme = localStorage.getItem("theme");
  const { levelOfTextDetail, setLevelOfTextDetail, selectedTone, setTone, audience, setAudience, language, setLanguage } = useWorkspace()
  const [anchorEl, setAnchorEl] = useState(null);
  const [openCategory, setOpenCategory] = useState(null);

  const handleLevelOfTextDetailChange = (level) => {
    setLevelOfTextDetail(level)
  }

   const open = Boolean(anchorEl);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

    const handleClose = () => {
    setAnchorEl(null);
  };

  const toTitleCase = (str) =>
  str.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());

  console.log("audience",audience)

  return (
    <div>
      <Box>
        <Typography
          variant="h6"
          gutterBottom
          style={{
            fontSize: "16px",
            fontWeight: "500",
            width: "158px",
            height: "20px",
            marginBottom: "20px",
          }}>
          Select Text Amount
        </Typography>
        <Grid container spacing={1} justifyContent="">
          {LevelOfDetail.map((level) => (
            <Grid item key={level}>
              <Button
                variant="outlined"
                onClick={() => handleLevelOfTextDetailChange(level)}
                sx={{
                  // width: "54px",
                  // height: "32px ",
                  backgroundColor: levelOfTextDetail === level ? "#3a3f69" : "#30355f",
                  // color: theme === "dark" ? "white" : "black",
                  color: "white",
                  "&:hover": {
                    backgroundColor: levelOfTextDetail === level ? "#3a3f69" : "",
                  },
                  borderColor: levelOfTextDetail === level ? "#cac4d0" : "transparent",
                  mx: 0.5, // Add horizontal margin for spacing
                }}
              >
                {level}
              </Button>
            </Grid>
          ))}
        </Grid>
      </Box>
      <Box mt={3}>
        <Typography variant="h6" gutterBottom sx={{ fontSize: "16px", fontWeight: 500, mb: 2 }}>
          Select Tone
        </Typography>

        <Grid container spacing={1}>
          {ToneOptions.map((tone) => (
            <Grid item key={tone}>
              <Button
                variant="outlined"
                onClick={() => setTone(tone)}
                sx={{
                  backgroundColor: selectedTone === tone ? "#3a3f69" : "#30355f",
                  color: "white",
                  border: "1px solid #565b85",
                  "&:hover": {
                    backgroundColor: selectedTone === tone ? "#3a3f69" : "#40446e",
                  },
                  borderColor: selectedTone === tone ? "#cac4d0" : "transparent",
                  mx: 0.5,
                }}
              >
                {tone}
              </Button>
            </Grid>
          ))}
        </Grid>
      </Box>

      <Box mt={3}>
        <Typography variant="h6" gutterBottom sx={{ fontSize: "16px", fontWeight: 500, mb: 2 }}>
          Select Professional Styles
        </Typography>

            <FormControl>
            <Button
              onClick={handleOpen}
              sx={{
                color: audience ? "rgba(255, 255, 255, 1)" : "rgba(202, 196, 208, 1)",
                backgroundColor: "#2F355F",
                borderRadius: "8px",
                height: "42px",
                minWidth: "500px",
                textTransform: "none",
                fontFamily: "Inter",
                "&:hover": {
                  backgroundColor: "#373E6D",
                },
              }}
            >
              {toTitleCase(audience) || "Audience"}
              <ArrowDropDownIcon
                sx={{
                  color: audience ? "white" : "rgba(202, 196, 208, 1)",
                  marginLeft: "auto",
                }}
              />
            </Button>

            <Popover
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              sx={{
                "& .MuiPaper-root": {
                  backgroundColor: "#2F355F",
                  color: "white",
                  borderRadius: "8px",
                  width: "500px",
                  maxHeight: "500px",
                  overflow: "hidden",
                },
              }}
            >

              {/* GROUPED OPTIONS */}
              {/* <Box sx={{ overflowY: "auto", maxHeight: 300 }}>
                {audienceOptions.map((group, idx) => (
                  <Box key={idx}>
                    <Box
                      sx={{
                        fontSize: 16,
                        fontWeight: 700,
                        opacity: 0.7,
                        px: 2,
                        py: 1,
                        textTransform: "uppercase",
                      }}
                    >
                      {group.category?.toUpperCase()}
                    </Box>

                    {group.items.map((item, index) => (
                      <MenuItem
                        key={index}
                        onClick={() => {setAudience(item); handleClose()}}
                        sx={{
                          "&:hover": { backgroundColor: "#373E6D" },
                          py: 1,
                          fontSize: 14,
                          color: "#FFFFFF",
                        }}
                      >
                        {toTitleCase(item)}
                      </MenuItem>
                    ))}
                  </Box>
                ))}
              </Box> */}
              {/* GROUPED OPTIONS WITH NESTED DROPDOWN */}
                  <Box sx={{ overflowY: "auto", maxHeight: 300 }}>

                    {audienceOptions.map((group, idx) => {
                      const isOpen = openCategory === idx;

                      return (
                        <Box key={idx}>

                          {/* CATEGORY ROW */}
                          <MenuItem
                            onClick={() => setOpenCategory(isOpen ? null : idx)}
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              fontSize: 15,
                              fontWeight: 600,
                              color: "white",
                              opacity: 0.9,
                              "&:hover": { backgroundColor: "#373E6D" },
                            }}
                          >
                            {group.category}

                            {isOpen ? (
                              <ArrowDropDownIcon />
                            ) : (
                              <AddIcon fontSize="small" />
                            )}
                          </MenuItem>

                          {/* SUB CATEGORY DROPDOWN */}
                          {/* {isOpen && (
                            <Box sx={{ pl: 2, backgroundColor: "#2A3056" }}>
                              {group.items.map((item, index) => (
                                <MenuItem
                                  key={index}
                                  onClick={() => {
                                    setAudience(item);
                                    handleClose();
                                    setOpenCategory(null);
                                  }}
                                  sx={{
                                    fontSize: 14,
                                    py: 1,
                                    color: "#FFFFFF",
                                    "&:hover": { backgroundColor: "#373E6D" },
                                  }}
                                >
                                  {toTitleCase(item)}
                                </MenuItem>
                              ))}
                            </Box>
                          )} */}
                          <Collapse in={isOpen} timeout={250} unmountOnExit>
                                <Box
                                  sx={{
                                    pl: 2,
                                    backgroundColor: "#2A3056",
                                    transition: "all 0.25s ease",
                                  }}
                                >
                                  {group.items.map((item, index) => (
                                    <MenuItem
                                      key={index}
                                      onClick={() => {
                                        setAudience(item);
                                        handleClose();
                                        setOpenCategory(null);
                                      }}
                                      sx={{
                                        fontSize: 14,
                                        py: 1,
                                        color: "#FFFFFF",
                                        "&:hover": { backgroundColor: "#373E6D" },
                                      }}
                                    >
                                      {toTitleCase(item)}
                                    </MenuItem>
                                  ))}
                                </Box>
                              </Collapse>
                        </Box>
                      );
                    })}

                  </Box>
            </Popover>
          </FormControl>

      </Box>
      {/* <Box mt={3}>
        <Typography
          variant="h6"
          gutterBottom
          sx={{ fontSize: "16px", fontWeight: 500, mb: 2 }}
        >
          Select Language
        </Typography>

        <Grid container spacing={1}>
          {LanguageOptions.map((lang) => (
            <Grid item key={lang.code}>
              <Button
                variant="outlined"
                onClick={() => setLanguage(lang.code)}   
                sx={{
                  backgroundColor: language === lang.code ? "#3a3f69" : "#30355f",
                  color: "white",
                  border: "1px solid #565b85",
                  "&:hover": {
                    backgroundColor: language === lang.code ? "#3a3f69" : "#40446e",
                  },
                  borderColor:  language === lang.code ? "#cac4d0" : "transparent",
                  mx: 0.5,
                }}
              >
                {lang.label}  
              </Button>
            </Grid>
          ))}
        </Grid>
      </Box> */}


    </div>
  )
}

export default TextContent